/**
 * @generated SignedSource<<9dfe1c2cbec30279f02d72f4341331ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowSiderailSoldPricingGuidance_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowSoldPricingGuidance_item">;
  readonly " $fragmentType": "useShowSiderailSoldPricingGuidance_item";
};
export type useShowSiderailSoldPricingGuidance_item$key = {
  readonly " $data"?: useShowSiderailSoldPricingGuidance_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowSiderailSoldPricingGuidance_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowSiderailSoldPricingGuidance_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSoldPricingGuidance_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8bbc319e4db644b72930e3825e097b40";

export default node;
